/**
 * Stabiele viewport-hoogte op mobiel: alleen bij load/orientatie, niet bij scroll
 * (voorkomt krimpen van #PageContainer wanneer de browserbalk terugkomt).
 */
(function () {
  'use strict';

  function setAppMinHeight() {
    var h = window.innerHeight;
    if (h < 200) return;
    document.documentElement.style.setProperty('--uf-app-min-height', h + 'px');
  }

  function init() {
    setAppMinHeight();
    window.addEventListener('orientationchange', function () {
      setTimeout(setAppMinHeight, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
